import { createTheme } from "@mui/material/styles";
import { colors } from "./Colors";
import { frFR } from "@mui/material/locale";

//MUI CUSTOM THEME
export const theme = createTheme(
  {
    palette: {
      primary: {
        main: colors.main,
        light: colors.light,
        dark: colors.dark,
        white: "#FFFFF",
      },
      neutral: {
        main: "#FFFFF",
      },
    },

    typography: {
      fontFamily: ["NeurialGrotesk-Regular"],
    },

    components: {
      MuiChip: {
        variants: [
          {
            props: {
              variant: "blue",
            },
            style: {
              color: "#003E9C",
              fontWeight: "600",
              background: "#E6F0FF",
              borderRadius: "6px",
              height: "22px",
              "& .MuiChip-label": {
                padding: "2px 4px",
              },
            },
          },
          {
            props: {
              variant: "green",
            },
            style: {
              color: "#2D8C61",
              fontWeight: "600",
              background: "#EDFCF5",
              borderRadius: "6px",
              padding: "6px 8px 6px 8px",

              height: "22px",
              "& .MuiChip-label": {
                padding: "2px 4px",
                lineHeight: "19.2px",
              },
            },
          },
          {
            props: {
              variant: "red",
            },
            style: {
              color: "#CC0000",
              fontWeight: "600",
              background: "#FAE6E6",
              padding: "6px 8px 6px 8px",
              borderRadius: "6px",
              height: "22px",
              "& .MuiChip-label": {
                padding: "2px 4px",
              },
            },
          },
          {
            props: {
              variant: "orange",
            },
            style: {
              color: "rgba(234, 91, 12, 1)",
              fontWeight: "600",
              background: "rgba(253, 239, 231, 1)",
              padding: "6px 8px 6px 8px",
              borderRadius: "6px",
              height: "22px",
              "& .MuiChip-label": {
                padding: "2px 4px",
              },
            },
          },

          {
            props: {
              variant: "regular",
            },
            style: {
              color: "#2E3755",
              fontWeight: "500",
              background: "#F5F5F7",
              borderRadius: "6px",
              padding: "4px 10px",
              lineHeight: "19.2px",
              "& .MuiChip-label": {
                padding: "2px 4px",
              },
              "& .MuiChip-deleteIcon": {
                color: "#2E3755",
              },
              "& .MuiChip-deleteIcon:hover": {
                color: "#2E3755",
              },
            },
          },
          {
            props: {
              variant: "yellow",
            },
            style: {
              color: "#c09d30",
              fontWeight: "500",
              background: "#ebdba4",
              borderRadius: "6px",
              padding: "4px 10px",
              lineHeight: "19.2px",
              "& .MuiChip-label": {
                padding: "2px 4px",
              },
              "& .MuiChip-deleteIcon": {
                color: "#c09d30",
              },
              "& .MuiChip-deleteIcon:hover": {
                color: "#c09d30",
              },
            },
          },
        ],
      },

      AppBar: {
        variants: [
          {
            props: {
              variant: "navbar",
            },
            style: {
              background: "white",
              color: colors.main,
            },
          },
        ],
      },

      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: "10px",
            fontSize: "0.875rem",
            backgroundColor: "white",
          },
        },
      },

      MuiTypography: {
        variants: [
          {
            props: {
              variant: "mini_title",
            },
            style: {
              fontSize: "1.3rem",
            },
          },
          {
            props: {
              variant: "text",
            },
            style: {
              fontSize: "0.875rem",
              color: colors.textDark,
              fontWeight: 500,
            },
          },
          {
            props: {
              variant: "text_gray",
            },
            style: {
              fontSize: "0.875rem",
              color: colors.gray,
              fontWeight: 500,
            },
          },
          {
            props: {
              variant: "text_gray_footer",
            },
            style: {
              cursor: "pointer",
              fontSize: "0.875rem",
              color: colors.gray,
              fontWeight: 500,
              "&:hover": {
                textDecoration: "underline",
                transition: "width 1s",
              },
            },
          },
          {
            props: {
              variant: "text_gray_description",
            },
            style: {
              fontSize: "0.875rem",
              color: colors.gray,
              fontWeight: 500,
              maxWidth: "620px",
              whiteSpace: "pre-line",
              overflowWrap: "break-word",
            },
          },
          {
            props: {
              variant: "text_normal",
            },
            style: {
              fontSize: "14px",
              color: "black",
              fontWeight: 400,
              whiteSpace: "pre-line",
              overflowWrap: "break-word",
              lineHeight: "22.4px",
            },
          },
          //XS
          {
            props: {
              variant: "text_xs",
            },
            style: {
              fontSize: "12px",
              color: "black",
              fontWeight: 400,
              whiteSpace: "pre-line",
              overflowWrap: "break-word",
              lineHeight: "22.4px",
            },
          },
          //SM
          {
            props: {
              variant: "text_sm",
            },
            style: {
              fontSize: "14px",
              color: "black",
              fontWeight: 400,
              whiteSpace: "pre-line",
              overflowWrap: "break-word",
              lineHeight: "22.4px",
            },
          },
          //MD
          {
            props: {
              variant: "text_md",
            },
            style: {
              fontSize: "16px",
              color: "black",
              fontWeight: 400,
              whiteSpace: "pre-line",
              overflowWrap: "break-word",
              lineHeight: "25.6px",
            },
          },
          //LG
          {
            props: {
              variant: "text_lg",
            },
            style: {
              fontSize: "20px",
              color: "black",
              fontWeight: 400,
              whiteSpace: "pre-line",
              overflowWrap: "break-word",
              lineHeight: "32px",
            },
          },
          //XM
          {
            props: {
              variant: "text_xl",
            },
            style: {
              fontSize: "28px",
              color: "black",
              fontWeight: 400,
              whiteSpace: "pre-line",
              overflowWrap: "break-word",
              lineHeight: "44.8px",
            },
          },
          //XXL
          {
            props: {
              variant: "text_xxl",
            },
            style: {
              fontSize: "32px",
              color: "black",
              fontWeight: 400,
              whiteSpace: "pre-line",
              overflowWrap: "break-word",
              lineHeight: "51.2px",
            },
          },
          //CLICKABLE
          {
            props: {
              variant: "text_clickable",
            },
            style: {
              fontSize: "14px",
              color: "#4079E9",
              fontWeight: 400,
              whiteSpace: "pre-line",
              overflowWrap: "break-word",
              cursor: "pointer",
              lineHeight: "22.4px",
              textDecoration: "underline",
            },
          },
          //GREEN
          {
            props: {
              variant: "text_green",
            },
            style: {
              fontSize: "14px",
              color: "#4EC944",
              fontWeight: 400,
              whiteSpace: "pre-line",
              overflowWrap: "break-word",
              cursor: "pointer",
              lineHeight: "22.4px",
            },
          },
        ],
      },
      MuiAutocomplete: {
        styleOverrides: {
          root: {
            color: colors.tFieldGray,
            "& .MuiInputBase-root": {
              height: "42px",
              padding: "0px 10px",
            },
            "& .MuiAutocomplete-input": {
              padding: "0px 10px !important",
            },
            "& .css-gqvsnj-MuiAutocomplete-root": {
              padding: "0px 10px",
            },
            "& .css-wq7oss-MuiAutocomplete-root": {
              padding: "0px 10px",
            },
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          root: {
            "& fieldset": {
              borderColor: "#DEDFE4",
              borderRadius: "6px",
              fontSize: "14px",
              lineHeight: "22.4px",
              fontWeight: "400",
              padding: "0px 10px",
            },
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            color: colors.tFieldGray,
            "& .MuiInputBase-root": {
              minHeight: "47px",
              padding: "0px 10px",
            },
            "& .MuiInputBase-input": {
              minHeight: "47px",
              padding: "0px 10px",
            },
            "& .MuiInputBase-inputMultiline": {
              borderRadius: "6px",
              fontSize: "14px",
              lineHeight: "22.4px",
              fontWeight: "400",
              padding: "10px 10px",
            },
            "& .MuiOutlinedInput-root": {
              padding: "0px 10px",

              minHeight: "47px",
              borderRadius: "6px",
              fontSize: "14px",
              lineHeight: "22.4px",
              fontWeight: "400",
              padding: "0px 10px",
              "& fieldset": {
                borderColor: "#DEDFE4",
                borderRadius: "6px",
                fontSize: "14px",
                lineHeight: "22.4px",
                fontWeight: "400",
                padding: "0px 10px",
              },
              "&:placeholder fieldset": {
                color: "#DEDFE4",
              },
              "&:hover fieldset": {
                border: `2px solid ${colors.main}`,
              },
              "&.Mui-focused fieldset": {
                border: `2px solid ${colors.main}`,
              },
            },
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: { minWidth: 0 },
        },
        //BUTTONS VARIANTS
        variants: [
          //MJ_BUTTON_PRIMARY
          {
            props: { variant: "primary" },
            style: {
              padding: "10px 12px",
              transition: "ease all 0.5s",
              fontSize: "12px",
              backgroundColor: colors.main,
              borderRadius: "6px",
              color: "white",
              "&:hover": {
                backgroundColor: colors.main,
                filter: "brightness(0.7)",
                color: "white",
              },
              textTransform: "none",
            },
          },
          //MJ_BUTTON_SECONDARY
          {
            props: { variant: "secondary" },
            style: {
              padding: "10px 12px",
              transition: "ease all 0.5s",
              fontSize: "12px",
              backgroundColor: "transparent",
              borderRadius: "6px",
              color: "black",
              "&:hover": {
                filter: "brightness(0.7)",
              },
              textTransform: "none",
            },
          },
          //MJ_BUTTON_GRAY
          {
            props: { variant: "gray" },
            style: {
              padding: "10px 12px",
              transition: "ease all 0.5s",
              fontSize: "12px",
              backgroundColor: "#EDEDED",
              borderRadius: "6px",
              color: "black",
              "&:hover": {
                backgroundColor: "#DADADA",
              },
              textTransform: "none",
            },
          },

          {
            props: { variant: "green" },
            style: {
              padding: "10px 12px",
              transition: "ease all 0.5s",
              fontSize: "12px",
              backgroundColor: "#49E59F",
              borderRadius: "6px",
              color: "white",

              "&:hover": {
                backgroundColor: "#49E59F",
                filter: "brightness(0.7)",
                color: "white",
              },
              textTransform: "none",
            },
          },
          {
            props: { variant: "red" },
            style: {
              padding: "10px 12px",
              transition: "ease all 0.5s",
              fontSize: "12px",
              backgroundColor: "#CC0000",
              borderRadius: "6px",
              color: "white",

              "&:hover": {
                backgroundColor: "#CC0000",
                filter: "brightness(0.7)",
                color: "white",
              },
              textTransform: "none",
            },
          },
          {
            props: { variant: "red_secondary" },
            style: {
              padding: "10px 12px",
              transition: "ease all 0.5s",
              fontSize: "12px",
              backgroundColor: "#FEE9E9",
              borderRadius: "6px",
              color: "#F42B2B",

              "&:hover": {
                backgroundColor: "#FEE9E9",
                filter: "brightness(0.7)",
                color: "#F42B2B",
              },
              textTransform: "none",
            },
          },
          {
            props: { variant: "dark" },
            style: {
              padding: "10px 12px",
              transition: "ease all 0.5s",
              fontSize: "12px",
              backgroundColor: "#161518",
              borderRadius: "6px",
              color: "white",

              "&:hover": {
                backgroundColor: "#161518",
                filter: "brightness(0.7)",
                color: "white",
              },
              textTransform: "none",
            },
          },
        ],
      },
    },
  },
  frFR
);
